import React from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { IconList } from '../../../../../../shared/icon/icon'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { useApiListSaveSnapshot } from '../../../../../../api-new/state/content'
import { TableAgClient } from '../../../../../../shared/table-builder/table-ag-client'
import { ColumnDateTime, ColumnMenu, ColumnText } from '../../../../../../shared/table-builder/table-columns'
import { Menu, MenuDelete, MenuEdit } from '../../../../../../shared/menu/menu'
import { Route, useRouteMatch } from '../../../../../../../node_modules/react-router-dom/cjs/react-router-dom.min'
import { NodeSaveSnapshotEdit } from './node-save-snapshot-edit'

export const NodeSaveSnapshotList = ({ nodeID }) => {
  const { url } = useRouteMatch()

  const apiListSaveSnapshot = useApiListSaveSnapshot(`/${nodeID}/node`)
  const apiListSaveSnapshotDelete = useApiListSaveSnapshot()

  const handleReady = () => apiListSaveSnapshot.get()

  const handleDelete = async id => {
    await apiListSaveSnapshotDelete.delete(id)
    await apiListSaveSnapshot.get()
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text="save system snapshots">
        <CardFullHeightScrollY title="save system snapshots">
          <TableAgClient apiList={apiListSaveSnapshot} onReady={handleReady}>
            <ColumnText field="email" />
            <ColumnText field="name" />
            <ColumnDateTime field="savedAt" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuEdit to={`${url}/${row.id}/edit`} show />
                  <MenuDelete onClick={() => handleDelete(row.id)} show />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>

      <Route path={`${url}/:id/edit`}>
        <NodeSaveSnapshotEdit nodeID={nodeID} parentURL={url} />
      </Route>
    </React.Fragment>
  )
}
